import ParameterValidator from '@mvps-genesis/parameter-validator';

export default class ContinueShopping {

	/**
	 * Parameter Validator class object
	 *
	 * @var	{ParameterValidator} @mvps-genesis/parameter-validator
	 */
	#validator;

	/**
	 * Collection of link elements
	 *
	 * @var {HTMLCollection|NodeList}
	 */
	links;

	/**
	 * List of screen codes
	 *
	 * @var {Array}
	 */
	screens;

	constructor ({
		links = '.js-continue-shopping',
		screens = [
			'CTGY',
			'PLST',
			'PROD',
			'SRCH'
		]
	} = {}) {
		this.#validator = new ParameterValidator(this);

		this.links = this.#validator.isElementList('links', links);
		this.screens = this.#validator.isArray('screens', screens);

		this.setContinueShoppingLink();
		this.bindEvents();
	}

	bindEvents () {
		for (const link of this.links) {
			link.addEventListener('click', this.onClick.bind(this), false);
		}
	}

	onClick (e) {
		const continueShoppingURL = sessionStorage.getItem('continue_url');

		if (continueShoppingURL) {
			e.preventDefault();
			window.location = continueShoppingURL;
		}
	}

	setContinueShoppingLink () {
		if (typeof window.mivaJS === 'object' && this.screens.indexOf(window.mivaJS.Screen) !== -1) {
			sessionStorage.setItem('continue_url', window.mivaJS.Breadcrumbs_Current_Item_Link);
		}
	};

}
